export default __webpack_public_path__ + "static/media/DSC06415.65de9de2.jpg";